import { CameraServiceProvider } from "./../providers/camera-service/camera-service";
import { Camera } from "@ionic-native/camera";
// import { CameraPreview } from '@ionic-native/camera-preview';
import { LoaderService } from "./../providers/loader";
import { Clipboard } from "@ionic-native/clipboard";
import { AnonymizeProvider } from "./../providers/anonymize/anonymize.provider";
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HttpModule } from "@angular/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { NativeGeocoder } from "@ionic-native/native-geocoder";
import { LaunchNavigator } from "@ionic-native/launch-navigator";
import { NativeStorage } from "@ionic-native/native-storage";
import { ScreenOrientation } from "@ionic-native/screen-orientation";
import { IonicStorageModule } from '@ionic/storage';
//import { BarcodeScanner } from '@ionic-native/barcode-scanner';
// import { ZBar } from '@ionic-native/zbar';

// Pages
import { MyApp } from "./app.component";
import { LoginPage } from "../pages/login/login";
import { EsqueciSenhaPage } from "../pages/esqueci-senha/esqueci-senha";

// Modules
import { HomePageModule } from "../pages/home/home.module";
import { ContratoModule } from "../pages/contratos/contratos.module";
import { ParticipacaoPageModule } from "../pages/participacao/participacao.module";
import { ReciclagemPageModule } from "../pages/reciclagem/reciclagem.module";
import { EcoEnelEmpresasPageModule } from "../pages/ecoenel-empresas/ecoenel-empresas.module";

// Services
import { ConfigService } from "./../providers/config-service";
import { HttpService } from "./../providers/http-service";
import { ConnectivityService } from "./../providers/connectivity-service";
import { LoginProvider } from "../providers/login/login.provider";
import { UserProvider } from "../providers/user/user.provider";
import { MenuProvider } from "../providers/menu/menu.provider";
import { PermissionService } from "../providers/permission-service";
import { EcoEnelEmpresasProvider } from "../providers/ecoenel-empresas/ecoenel-empresas.provider";
import { SenhaProvider } from "../providers/senha/senha.provider";

import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
  declarations: [MyApp, LoginPage, EsqueciSenhaPage],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    ContratoModule,
    HomePageModule,
    ParticipacaoPageModule,
    ReciclagemPageModule,
    EcoEnelEmpresasPageModule,
    HttpClientModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    EsqueciSenhaPage,
    //HomePage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ConnectivityService,
    ConfigService,
    HttpService,
    NativeGeocoder,
    LaunchNavigator,
    NativeStorage,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    LoginProvider,
    SenhaProvider,
    UserProvider,
    MenuProvider,
    PermissionService,
    ScreenOrientation,
    Clipboard,
    LoaderService,
    CameraServiceProvider,
    Camera,
    AnonymizeProvider,
    EcoEnelEmpresasProvider,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts